import wretch from 'wretch';
import formData from 'wretch/addons/formData';
import queryString from 'wretch/addons/queryString';

import { getApiBaseUrl, withProjectPath } from 'services/projectContext';

// API URL constants
export const AGORA_API_URL = '/agora';
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUCTION_API_URL = '/auctions';
export const AUTH_API_URL = '/authorization';
export const CLAIM_API_URL = '/claim';
export const CLIENT_API_URL = '/clients';
export const GO_LIVE_API_URL = '/go-live';
export const INTAKE_CASE_API_URL = '/intake-case';
export const NDP_API_URL = '/ndp';
export const NOTIFICATION_API_URL = '/notifications';
export const ONBOARDING_API_URL = '/onboarding';
export const OPPORTUNITY_CURATOR_API_URL = '/opportunity-curator';
export const PAYER_REQUEST_API_URL = '/payer_request';
export const PERFORMANCE_API_URL = '/performance';
export const PBM_API_URL = '/pbm';
export const PRIOR_AUTH_MANAGER_API_URL = '/prior-auth';
export const RATE_SETTER_API_URL = '/ratesetter';
export const REFERENCE_API_URL = '/reference';
export const SCOPE_ASSESSOR_API_URL = '/scope-assessor';
export const TREATMENT_API_URL = '/treatment';
export const TREATMENT_AUDIT_API_URL = '/treatment-audit';
export const USER_SUPPORT_API_URL = '/user-support';
export const WORKLIST_API_URL = '/worklist';
export const X_COM_API_URL = '/x-com';

/**
 * Routes every request path through withProjectPath at fetch time, so service
 * prefixes claimed by the active project get /proj/<name>-prefixed while
 * unclaimed services keep bare paths served by shared dev. Runs after the
 * queryString addon, so the query string is split off before the prefix check.
 */
const projectPathMiddleware = (next) => (url, opts) => {
    const base = getApiBaseUrl() ?? '';
    if (!url.startsWith(base)) {
        return next(url, opts);
    }
    const queryIndex = url.indexOf('?', base.length);
    const path = queryIndex === -1 ? url.slice(base.length) : url.slice(base.length, queryIndex);
    const query = queryIndex === -1 ? '' : url.slice(queryIndex);
    return next(`${base}${withProjectPath(path)}${query}`, opts);
};

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = {
    base: wretch(getApiBaseUrl())
        .middlewares([projectPathMiddleware])
        .addon([formData, queryString]),
};
